const getUserAgent = () => (typeof navigator !== 'undefined' ? navigator.userAgent : '');

const is = {
  windows: () => /Win/i.test(getUserAgent()),
  chrome: () => /Chrome/i.test(getUserAgent()) && !/Edg|OPR/i.test(getUserAgent()),
  firefox: () => /Firefox/i.test(getUserAgent()),
  safari: () => /Safari/i.test(getUserAgent()) && !/Chrome|Chromium|Edg|OPR|Android/i.test(getUserAgent()),
  ipad: () => /iPad/i.test(getUserAgent()) || (/Macintosh/i.test(getUserAgent()) && typeof document !== 'undefined' && 'ontouchend' in document),
  mobile: () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(getUserAgent())
};

export default is;
